(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

  
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image_bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  if (!modal || images.length === 0) return; // Falls keine Bilder oder Modal existieren, abbrechen
  
  const modalImage = modal.querySelector('img');
  const prevArrow = modal.querySelector('.mw-modal-prev');
  const nextArrow = modal.querySelector('.mw-modal-next');
  const closeButton = modal.querySelector('.mw-modal-close'); // X-Button
  
  let currentIndex = 0;

  // Öffnet das Modal und zeigt das geklickte Bild
  function showModal(index) {
    if (index >= 0 && index < images.length) {
      if (window.innerWidth > 749) {
        modalImage.src = images[index].dataset.desktop || images[index].href; 
      } else {
        modalImage.src = images[index].dataset.mobile || images[index].href;  
      }
      
      modal.classList.add('show');
      currentIndex = index;
    }
  }

  // Modal ausblenden
  function hideModal(e) {
    e.preventDefault(); // Verhindert das Standardverhalten von `<a href="#">`
    if (e.target === modal || e.target === closeButton) {
      modal.classList.remove('show');
    }
  }

  // Vorheriges Bild anzeigen
  function showPrevImage(e) {
    e.preventDefault(); 
    e.stopPropagation(); 
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }

  // Nächstes Bild anzeigen
  function showNextImage(e) {
    e.preventDefault();
    e.stopPropagation();
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }

  // Klick-Event für alle Bilder in der Galerie
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault();
      showModal(index);
    });
  });

  // Klick-Event für Navigationspfeile
  prevArrow.addEventListener('click', showPrevImage);
  nextArrow.addEventListener('click', showNextImage);

  // Modal durch Klick auf Hintergrund schließen
  modal.addEventListener('click', hideModal);

  // **Fix für X-Button (schließen)**
  if (closeButton) {
    closeButton.addEventListener('click', hideModal);
  }

})();

  } catch(e) { console.error(e); }
})();
})();
